import React, { useEffect, useState } from 'react';
import client from '../contenful/client';
import Gallery from '../components/Gallery';
import '../pages/Project.css';
import { useParams } from "react-router-dom";

const Projectlib = ({ limit = null, allProjects = null, currentSlug = null }) => {
  const [projects, setProjects] = useState([]);
  const { slug } = useParams();

  useEffect(() => {
    const fetchData = async () => {
      try {
        let items = allProjects?.length
          ? allProjects
          : (await client.getEntries({ content_type: "projects" })).items;

        // ✅ remove current project
        if (currentSlug) {
          items = items.filter(p => p.fields.slug !== currentSlug);
        }

        // ✅ shuffle and slice if limit is provided
        if (limit && items.length > limit) {
          items = shuffleArray(items).slice(0, limit);
        }

        setProjects(items);
      } catch (err) {
        console.error("Error fetching Contentful data:", err);
      }
    };

    fetchData();
  }, [limit, allProjects, currentSlug]);

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  return (
    <div className="project-library">
      {projects.map((item, index) => {
        const selectedGrids = item.fields.selectedGrids || [];
        return selectedGrids.map((grid, subIndex) => {
          const image = `https:${grid.fields.file.url}`;
          const title = grid.fields.title || "";
          const slug = item?.fields?.slug;

          return (
            <Gallery
              key={`${index}-${subIndex}`}
              image={image}
              title={title}
              link={`/projects/${slug}`}
              state={{ project: item, allProjects: projects }}
            />
          );
        });
      })}
    </div>
  );
};

export default Projectlib;
